import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
    template: '', // This is a dummy route that simply redirects the user to CDAS
    standalone: true,
})
export class HelpComponent implements OnInit {
    public constructor(private readonly location: Location) {}

    public ngOnInit(): void {
        // Open CDAS in new tab
        window.open(
            'https://cdas.azure.chevron.com/ITF-DataQualityRemediationandManagement-Wiki/Overview.html',
            '_blank',
        );

        // Go back to the previous page (so that the user isn't stuck in /help)
        this.location.back();
    }
}
